import React, { useState, useEffect, useRef } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useTranslation } from 'react-i18next';
import personIcon from '../assets/Person.png'; // Update path according to your project

const PersonDetails = () => {
  const { t, i18n } = useTranslation();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [adults, setAdults] = useState(1);
  const [children, setChildren] = useState(2);

  const dropdownRef = useRef(null);

  const incrementAdults = () => setAdults(prev => prev + 1);
  const decrementAdults = () => setAdults(prev => (prev > 1 ? prev - 1 : 1));

  const incrementChildren = () => setChildren(prev => prev + 1);
  const decrementChildren = () => setChildren(prev => (prev > 0 ? prev - 1 : 0));

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div className="selector position-relative fixed-box-child" id="guestsSelector">
      <div className="selector border-0 p-0 m-0 w-100 position-relative border" ref={dropdownRef}>
        {/* Main Button */}
        <div
          className="d-flex align-items-center justify-content-between w-100"
          style={{ cursor: 'pointer' }}
          onClick={() => setDropdownOpen(!dropdownOpen)}
        >
          <div className="d-flex align-items-center">
            <img src={personIcon} alt="Person" className="me-2" style={{ width: '30px' }} />
            <div>
              <span>{adults} {t("Adults")}</span>{" "}
              <span className="ms-2">{children} {t("Children")}</span>
            </div>
          </div>
          <div className="btn-arrow-top-bottom d-flex flex-column ms-2">
            <span className="arrow p-0 m-0">
              <svg width="13" height="7" viewBox="0 0 13 7" fill="none"
                   xmlns="http://www.w3.org/2000/svg" className="p-0 m-0 mb-1">
                <path d="M1 6.5L6.5 1L12 6.5" stroke="#F49B31" strokeLinecap="round" />
              </svg>
            </span>
            <span className="arrow p-0 m-0">
              <svg width="13" height="7" viewBox="0 0 13 7" fill="none"
                   xmlns="http://www.w3.org/2000/svg" className="p-0 m-0 mt-1">
                <path d="M11.9925 0.797026L6.70108 6.49798L1.00012 1.20657"
                      stroke="#F49B31" strokeLinecap="round" />
              </svg>
            </span>
          </div>
        </div>

        {/* Dropdown */}
        {dropdownOpen && (
          <div
            className="dropdown position-absolute bg-white border p-3 mt-3 d-block"
            style={{ zIndex: 100, width: '100%' }}
          >
            <div className="dropdown-row d-flex align-items-center justify-content-between mb-2">
              <span>{t("Adults")}</span>
              <div className="counter btn-group">
                <button className="btn btn-outline-primary p-0" onClick={decrementAdults}>-</button>
                <span className="px-0">{adults}</span>
                <button className="btn btn-outline-primary p-0" onClick={incrementAdults}>+</button>
              </div>
            </div>
            <div className="dropdown-row d-flex align-items-center justify-content-between">
              <span>{t("Children")}</span>
              <div className="counter btn-group">
                <button className="btn btn-outline-primary p-0" onClick={decrementChildren}>-</button>
                <span className="px-0">{children}</span>
                <button className="btn btn-outline-primary p-0" onClick={incrementChildren}>+</button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default PersonDetails;
